import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getPrices, PricingItemResponse } from '../../api/pricingAPI';

export interface PricingState {
  values: PricingItemResponse[] | null;
  isLoading: boolean;
  error: string | null;
  keys: string[];
}

const initialState: PricingState = {
  values: null,
  isLoading: false,
  error: null,
  keys: [],
};

export interface FetchPrices {
  items: ProductPrice[];
  token: string;
  language: string;
}

export interface ProductPrice {
  item: string;
  material: string;
  quantity: number;
  icode1: string;
}

function startLoading(state: PricingState) {
  state.isLoading = true;
}

export const fetchPrices = createAsyncThunk('fetchPrices', async ({ items, token, language }: FetchPrices) => {
  // We have to ensure that the material property returned by the API, it will
  // be processed as string, because after such property will be accessed in order to compare it
  // with string values.
  return await getPrices(items, token, language).catch();
});

export const pricingSlice = createSlice({
  name: 'pricing',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchPrices.pending, startLoading);
    builder.addCase(fetchPrices.fulfilled, (state, { payload }) => {
      state.values = payload;
      state.isLoading = false;
      state.error = null;
    });
    builder.addCase(fetchPrices.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message || 'Fetching prices failed';
    });
  },
});

export default pricingSlice.reducer;
